import { Iata } from 'types/Search/airport';

export interface RecommendationProps {
    airport: {
        code: Iata;
        name: string;
    };
    type: string;
}

export interface Airport {
    iataCode: Iata;
    label: string;
}

export interface AirportAcRequest {
    /** version */
    v: string;
    /** searchTerm */
    term: string;
    acAirportVersion: string;
    regionId?: number;
}

export interface AirportAcItem {
    id?: string;
    label: string;
    lvl: string;
    subLabel: string;
    type: ItemType;
    value: Iata;
    parent?: string;
    distance?: number;
}

export type AirportAcItemList = Array<AirportAcItem>;
export type AirportAcResponse = Array<AirportAcItemList>;

export enum Country {
    Austria = 'Austria',
    Belgium = 'Belgium',
    CzechRepublic = 'Czech Republic',
    Denmark = 'Denmark',
    France = 'France',
    Germany = 'Germany',
    Italy = 'Italy',
    Luxembourg = 'Luxembourg',
    Netherlands = 'Netherlands',
    Poland = 'Poland',
    Slovakia = 'Slovakia',
    Slovenia = 'Slovenia',
    Switzerland = 'Switzerland',
}

export enum Region {
    North = 'North',
    East = 'East',
    South = 'South',
    West = 'West',
}

export interface RegionAirportList {
    region: Region;
    iataCodeList: Set<Iata>;
}

export type AirportMap = Record<Iata, { label: string; country: Country }>;

export interface AirportCountry {
    iataCodeList: Set<Iata>;
    regionList?: RegionAirportList[];
    active: boolean;
}

export enum ItemType {
    Price = 'price',
    Popular = 'popular',
    AcAirport = 'ac-airport',
    AcAirportRegion = 'ac-airport-region',
    OnlyRegion = 'only',
}
